export const skills = [
  ["./js.png", "JavaScript"],
  ["nodejs.png", "Node JS"],
  ["./express.png", "Express JS"],
  ["./react.png", "React JS"],
  ["./redux.png", "Redux"],
  ["/mongo.png", "Mongo DB"],
  ["./html.png", "HTML"],
  ["./css.png", "CSS"],
  ["./mui.png", "Material UI"],
  ["./sql.png", "SQL"],
  ["./cypress.svg", "Cypress"],
  ["./git-icon.svg", "GIT"]
];
